<template>
  <div>
    <!-- Mobile overlay -->
    <div
      class="overlaytopbar"
      v-if="isOpen"
      @click="isOpen = $refs.menuIcon.checked = false"
    ></div>

    <header class="element-to-hide login-profile-topbar-A01">
      <!-- Sidebar toggle -->
      <button class="toggle-btn" @click="$emit('toggle-sidebar')">
        <img src="../assets/topbar/sidebar-open.svg" height="30px" alt="sidebar-open" loading="lazy" />
      </button>

      <!-- Search bar (same as doc2) -->
      <div class="topbar">
        <multiselect
          v-model="selectedValues"
          :options="combinedList"
          :custom-label="customLabel"
          @select="handleOptionSelect"
          placeholder="Select an option or type to search"
        ></multiselect>
      </div>

      <!-- Mobile hamburger -->
      <input type="checkbox" id="mobile-icon" @change="isOpen = $event.target.checked" ref="menuIcon" />
      <label for="mobile-icon" class="toggle"><span class="hamburger-icon"></span></label>

      <nav>
        <ul class="nav-items">

          <!-- Home -->
          <li>
            <router-link to="/">
              <img src="@/assets/topbar/home.svg" alt="home" loading="lazy" width="24px" />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-home" style="width:100%">Home<span class="arrow">&#x25bc;</span></label>
            </router-link>
            <input id="submenu-home" type="checkbox" />
            <ul class="submenu-home">
              <li><router-link to="/" class="goto-page-link">Home</router-link></li>
            </ul>
          </li>

          <!-- Who I Am -->
          <li>
            <a href="#">
              <img src="@/assets/topbar/stethoscope.svg" alt="who i am" loading="lazy" width="24px" />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-1" style="width:100%">Who I Am<span class="arrow">&#x25bc;</span></label>
            </a>
            <input id="submenu-1" type="checkbox" />
            <ul class="submenu-1">
              <li><a href="#" class="disabledSection">Who I Am</a></li>
              <li><router-link to="/doctor-calender-setup">My Planner | Calender</router-link></li>
              <li><router-link to="/Affiliate_Associate">Become Affiliate | Associate</router-link></li>
              <li><router-link to="/my-appointment-daybook">My Daybook | Appointments</router-link></li>
              <li><router-link to="/Coming_Soon">My Meeting</router-link></li>
              <li><router-link to="/blogs">All Blog</router-link></li>
            </ul>
          </li>

          <!-- Involvements -->
          <li>
            <a href="#">
              <img src="@/assets/topbar/team.svg" alt="involvements" loading="lazy" width="26px" />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-4" style="width:100%">Involvements<span class="arrow">&#x25bc;</span></label>
            </a>
            <input id="submenu-4" type="checkbox" />
            <ul class="submenu-4">
              <li><a href="#" class="disabledSection">Involvements</a></li>
              <li><router-link to="/Coming_Soon">My Team</router-link></li>
              <li><router-link to="/savedandAppliedJobs">My Job Board</router-link></li>
              <li><router-link to="/Coming_Soon">My Groups</router-link></li>
              <li><router-link to="/my-blogs">My Blog</router-link></li>
              <li><router-link to="/Coming_Soon">My Lectures/Tutorial</router-link></li>
            </ul>
          </li>

          <!-- Notifications -->
          <li>
            <router-link to="/notificationspage" style="position:relative">
              <span class="count hide-mobile" style="position:absolute; right:18px">{{ unreadNotificationCount }}</span>
              <img src="../assets/topbar/notification.svg" alt="notification" loading="lazy" height="24px" />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-3" style="width:100%">Notifications<span class="arrow">&#x25bc;</span></label>
            </router-link>
            <ul class="submenu-3">
              <li><router-link to="/notificationspage" class="goto-page-link">Notification</router-link></li>
            </ul>
          </li>

          <!-- Portfolio -->
          <li>
            <a href="#">
              <img src="@/assets/topbar/office_bag.svg" alt="portfolio" loading="lazy" width="25px" />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-6" style="width:100%">Portfolio<span class="arrow">&#x25bc;</span></label>
            </a>
            <input id="submenu-6" type="checkbox" />
            <ul class="submenu-6">
              <li><a href="#" class="disabledSection">Portfolio</a></li>
              <li><router-link to="/coinsDashboard">My Coins</router-link></li>
              <li><router-link to="/my-credits">My Credits</router-link></li>
              <li><router-link to="/Doctor-Profile-Details">My Resume</router-link></li>
              <li><router-link to="/subscribers">My Subscriptions</router-link></li>
              <li><router-link to="/FamilyManagement">My Family</router-link></li>
            </ul>
          </li>

          <!-- Events -->
          <li>
            <router-link to="/Coming_Soon">
              <img src="@/assets/topbar/docs.svg" alt="events" loading="lazy" width="24px" />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-ev" style="width:100%">Events<span class="arrow">&#x25bc;</span></label>
            </router-link>
            <input id="submenu-ev" type="checkbox" />
            <ul class="submenu-ev">
              <li><router-link to="/Coming_Soon" class="goto-page-link">Events</router-link></li>
            </ul>
          </li>

          <!-- Mail -->
          <li>
            <router-link to="/Coming_Soon">
              <img src="@/assets/topbar/message.svg" alt="mail" loading="lazy" width="24px" />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-8" style="width:100%">Mail<span class="arrow">&#x25bc;</span></label>
            </router-link>
            <input id="submenu-8" type="checkbox" />
            <ul class="submenu-8">
              <li><router-link to="/Coming_Soon" class="goto-page-link">Mail</router-link></li>
            </ul>
          </li>

          <!-- Cart -->
          <li>
            <router-link to="/AddCart" style="position:relative">
              <span class="count hide-mobile">{{ cartItemCount }}</span>
              <img src="@/assets/topbar/shopping.svg" alt="cart" loading="lazy" width="24px" />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-9" style="width:100%">Cart<span class="arrow">&#x25bc;</span></label>
            </router-link>
            <input id="submenu-9" type="checkbox" />
            <ul class="submenu-9">
              <li><router-link to="/AddCart" class="goto-page-link">Cart</router-link></li>
            </ul>
          </li>

          <!-- Settings -->
          <li>
            <a href="javascript:void(0)" @click.stop="toggleVisibility">
              <img src="@/assets/topbar/setting.svg" alt="setting" loading="lazy" width="24px" />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label style="width:100%; pointer-events:none">Settings</label>
            </a>
          </li>

          <!-- Logout -->
          <li>
            <a href="javascript:void(0)" @click="logout">
              <img src="@/assets/topbar/logout.svg" alt="logout" loading="lazy" width="20px" />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label style="width:100%; pointer-events:none">Logout</label>
            </a>
          </li>

        </ul>
      </nav>
    </header>

    <!-- Settings Panel -->
    <div v-if="isVisible" class="setting-box" @click.self="isVisible = false">
      <div class="TopbarSetting" ref="TopbarSetting">
        <p class="pageSettingHeading">⚙ Settings</p>
        <hr class="PagrHR" />

        <p class="layoutHeading" style="margin-left:15px">Region & Language</p>
        <div class="layout">
          <div class="select">
            <LanguageSelector :allLanguageData="NewLangData" @update:language="updateLanguage" />
          </div>
        </div>
        <hr class="PagrHR" />

        <div class="layoutBackground">
          <p style="font-size:12px; margin-left:13px; margin-top:9px">Edit Mode</p>
          <button class="editBackgroundBtn" @click="togglePopup">Toggle Visibility</button>
        </div>
        <hr class="PagrHR" />

        <div class="layoutBackground">
          <p style="font-size:12px; margin-left:13px; margin-top:9px">Custom Theme</p>
          <input style="margin:4px; margin-left:13px; width:83%" type="color" @change="changeColor($event.target.value)" class="color-picker" />
        </div>
        <hr class="PagrHR" />

        <p style="font-weight:500; font-size:14px; margin-left:11px; margin-top:8px">Theme</p>
        <div class="ThemeSelection">
          <div @click="changeColor('linear-gradient(90deg, rgb(255,255,255) 50%, rgb(44,54,63) 50%)')"         class="theme" style="background-image:linear-gradient(90deg,rgb(255,255,255) 50%,rgb(44,54,63) 50%)"></div>
          <div @click="changeColor('linear-gradient(45deg, rgb(114,130,251), rgb(121,52,247))')"               class="theme" style="background-image:linear-gradient(45deg,rgb(114,130,251),rgb(121,52,247))"></div>
          <div @click="changeColor('linear-gradient(45deg, rgb(243,176,73), rgb(234,125,86), rgb(212,32,125))')" class="theme" style="background-image:linear-gradient(45deg,rgb(243,176,73),rgb(234,125,86),rgb(212,32,125))"></div>
          <div @click="changeColor('linear-gradient(45deg, rgb(160,185,82), rgb(79,164,109), rgb(0,160,160))')"  class="theme" style="background-image:linear-gradient(45deg,rgb(160,185,82),rgb(79,164,109),rgb(0,160,160))"></div>
          <div @click="changeColor('linear-gradient(45deg, rgb(38,176,177), rgb(19,115,170), rgb(0,52,163))')"   class="theme" style="background-image:linear-gradient(45deg,rgb(38,176,177),rgb(19,115,170),rgb(0,52,163))"></div>
          <div @click="changeColor('linear-gradient(45deg, rgb(141,125,162), rgb(89,73,110), rgb(32,15,53))')"   class="theme" style="background-image:linear-gradient(45deg,rgb(141,125,162),rgb(89,73,110),rgb(32,15,53))"></div>
          <div @click="changeColor('linear-gradient(45deg, rgb(28,62,92), rgb(28,62,92), rgb(28,62,92))')"       class="theme" style="background-image:linear-gradient(45deg,rgb(28,62,92),rgb(28,62,92),rgb(28,62,92))"></div>
          <div @click="changeColor('radial-gradient(circle at 10% 20%, rgb(97,186,255) 0%, rgb(166,239,253) 90.1%)')" class="theme" style="background-image:radial-gradient(circle at 10% 20%,rgb(97,186,255) 0%,rgb(166,239,253) 90.1%)"></div>
          <div @click="changeColor('linear-gradient(65.9deg, rgb(85,228,224) 5.5%, rgba(75,68,224,0.74) 54.2%, rgb(64,198,238) 55.2%, rgb(177,36,224) 98.4%)')" class="theme" style="background-image:linear-gradient(65.9deg,rgb(85,228,224) 5.5%,rgba(75,68,224,0.74) 54.2%,rgb(64,198,238) 55.2%,rgb(177,36,224) 98.4%)"></div>
          <div @click="changeColor('linear-gradient(67.6deg, rgba(225,242,254,1) -2.8%, rgba(193,224,250,1) 44.6%, rgba(19,116,197,1) 102.4%)')" class="theme" style="background-image:linear-gradient(67.6deg,rgba(225,242,254,1) -2.8%,rgba(193,224,250,1) 44.6%,rgba(19,116,197,1) 102.4%)"></div>
          <div @click="changeColor('linear-gradient(45deg, rgb(92,96,112), rgb(55,58,67))')"                     class="theme" style="background-image:linear-gradient(45deg,rgb(92,96,112),rgb(55,58,67))"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import presenceSocket from "@/services/presenceSocket";
const toast = useToast();
import { useStore, mapActions, mapGetters } from "vuex";
import multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import dummyData from "./dummyData.js";
import LanguageSelector from "./LanguageSelector.vue";
import axios from "axios";

export default {
  name: "Topbar_page",

  components: { multiselect, LanguageSelector },

  props: {
    msg: String,
    currentURL: String,
    resetpass: Boolean,
    languages: Array,
    language: String,
    NewLangData: Array,
  },

  setup() {
    const store = useStore();
    const toggleVisibilityEdit = () => store.commit("toggleVisibility");
    return { toggleVisibilityEdit };
  },

  data() {
    return {
      colorChangeTimeout: null,
      SHOWSIDEBAR: false,
      medicines: dummyData.medicines,
      isVisible: false,
      isVisible1: false,
      searchName: "",
      isNavMenuVisible: false,
      showLabel: true,
      cartItemCount: 0,
      doctors: [],
      isOpen: false,

      // ---- search bar (same as doc2) ----
      selectedValues: [],
      routesList: [],
      resumeList: [],
      transactionCodes: [],
      searchList: {},
      doctorPage: "",
    };
  },

  computed: {
    // ---- search bar (same as doc2) ----
    combinedList() {
      return [...this.routesList, ...this.resumeList, ...dummyData.medicines, ...this.transactionCodes];
    },
    filteredDoctors() {
      if (this.searchName.trim() === "") return this.doctors;
      return this.doctors.filter((d) =>
        d.name.toLowerCase().includes(this.searchName.toLowerCase())
      );
    },
    ...mapGetters(["unreadNotificationCount"]),
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.fetchCartCount();
    this.getData();
    this.getDataDoctor();
    this.getResumeData();
    this.loadSavedTheme();
    this.fetchData(); // search bar routes (same as doc2)
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    // ── Settings ──
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },

    // ── Search bar (same as doc2) ──
    customLabel(option) {
      switch (option.type) {
        case "route":
          return option.path ? `  ${option.path}` : option.name;
        case "resume":
          return `${option.selectedTitle} ${option.Firstname} ${option.MiddleName ? option.MiddleName + " " : ""}${option.LastName} in Doctor-Profile`;
        case "transactionCode":
          return `Transaction Code - ${option.transaction_id}`;
        default:
          if (option.name && option.seller) {
            const nameWithoutSpecialChars = option.name.replace(/[^\w\s]/gi, "");
            const sellerWithoutSpecialChars = option.seller.replace(/[^\w\s]/gi, "");
            const nameWithoutSpaces = nameWithoutSpecialChars.replace(/\s/g, "");
            const sellerWithoutSpaces = sellerWithoutSpecialChars.replace(/\s/g, "");
            return `${nameWithoutSpaces}-${sellerWithoutSpaces}`;
          } else {
            return option.Firstname || option.path || "Unknown";
          }
      }
    },

    handleOptionSelect(selectedOption) {
      switch (selectedOption.type) {
        case "route":
          this.$router.push(`/${selectedOption.path}`);
          break;
        case "transactionCode":
          this.$router.push(`/${selectedOption.object_component_name}`);
          break;
        case "resume":
          this.$router.push({ name: "view-Doctor", params: { userId: selectedOption.user_id } });
          this.$store.dispatch("fetchSpecificResume", selectedOption.user_id);
          break;
        case "vendor":
          this.$router.push(`/checkout/${selectedOption.mid}`);
          break;
        default:
          break;
      }
    },

    async fetchData() {
      try {
        let response = await this.fetchRoutes();
        this.routesList = response;
        for (let route of this.routesList) {
          route.type = "route";
        }
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    },

    // ── Theme ──
    loadSavedTheme() {
      const savedColor = localStorage.getItem("userThemeColor");
      if (savedColor) this.applyThemeColor(savedColor);
      this.fetchProductDetails();
    },

    applyThemeColor(color) {
      if (!color) return;
      const containers = document.getElementsByClassName("adminPageContainer");
      const dates = document.getElementsByClassName("timeline__event__date");
      if (containers.length > 0) containers[0].style.background = color;
      if (dates.length > 0) dates[0].style.background = color;
    },

    changeColor(colorValue) {
      if (this.colorChangeTimeout) clearTimeout(this.colorChangeTimeout);
      this.applyThemeColor(colorValue);
      this.colorChangeTimeout = setTimeout(() => {
        const formData = new FormData();
        formData.append("color_code", colorValue);
        formData.append("user_id", this.$store.getters.hasuserdetails?._id);
        axios
          .post(process.env.VUE_APP_BASE_URL + "profile-customization/change_bgcolor", formData, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          })
          .then(() => {
            localStorage.setItem("userThemeColor", colorValue);
            toast.success("Theme changed successfully!");
          })
          .catch((err) => {
            console.error(err);
            toast.error("Failed to save theme.");
          });
      }, 1000);
    },

    fetchProductDetails() {
      const userId = this.$store.getters.hasuserdetails?._id;
      if (!userId) return;
      axios
        .post(`${process.env.VUE_APP_BASE_URL}profile-customization/get_doctorDatabyid`, { id: userId })
        .then((res) => {
          const data = res.data.Data;
          if (data?.color_code) {
            localStorage.setItem("userThemeColor", data.color_code);
            this.applyThemeColor(data.color_code);
          }
        })
        .catch((err) => console.error("Theme fetch error:", err));
    },

    // ── Cart ──
    async fetchCartCount() {
      try {
        const user = this.$store.getters.hasuserdetails;
        if (!user?._id) { this.cartItemCount = 0; return; }
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}addTocart/get-cart-count`,
          { params: { userId: user._id } }
        );
        this.cartItemCount = res.data.success ? res.data.count : 0;
      } catch {
        this.cartItemCount = 0;
      }
    },

  
   async logout() {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_BASE_URL}auth/logout`,
      {
        withCredentials: true,
      }
    );

    this.$store.state.userdetails = "";
    presenceSocket.disconnect();

    sessionStorage.removeItem("user");
    sessionStorage.clear();

    toast.clear();
    toast.success(response.data.message);

    this.$router.push({ path: "/" });

  } catch (error) {
    console.error("Logout failed:", error);
    toast.error(error.response?.data?.message || "Failed to logout");
  }
},

    // ── Resume / Data ──
    async getResumeData() {
      try {
        await this.getAllResumes();
      } catch (e) {
        console.error(e);
      }
    },

    async getData() {
      try {
        const res = await fetch(process.env.VUE_APP_BASE_URL + "resume/get-resumes");
        if (!res.ok) throw new Error("Failed");
        const data = await res.json();
        this.doctors = data.map((r) => ({ _id: r._id, name: r.name }));
      } catch (e) {
        console.error(e);
      }
    },

    async getDataDoctor() {
      try {
        const res = await fetch(process.env.VUE_APP_BASE_URL + "resume/get-resumesDoctor");
        if (!res.ok) throw new Error("Failed");
        const data = await res.json();
        this.doctors = data.map((r) => ({ _id: r._id, name: r.name }));
      } catch (e) {
        console.error(e);
      }
    },

    // ── Misc ──
    updateLanguage(newLanguage) {
      this.$emit("update:language", newLanguage);
    },

    handleResize() {
      this.showLabel = window.innerWidth <= 1000;
    },

    redirectToAssociates() {
      this.$router.push("/associate-registration");
    },

    ...mapActions(["fetchRoutes", "getAllResumes", "toggleDiv"]),

    togglePopup() {
      this.toggleDiv();
    },
  },
};
</script>

<style scoped>
/* ===== Base reset ===== */
* { box-sizing: border-box; margin: 0; padding: 0; }

/* ===== Header ===== */
.login-profile-topbar-A01 {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  position: fixed;
  width: 100%;
  z-index: 999;
  border-bottom: 1px solid grey;
  height: 53px;
}

/* ===== Toggle / Hamburger ===== */
.toggle {
  cursor: pointer;
  padding: 25px 10px;
  position: relative;
}
.toggle-btn {
  background: none;
  display: none;
  border: none;
  cursor: pointer;
  margin-right: 16px;
}
@media screen and (max-width: 768px) {
  .toggle-btn { display: block; }
}

/* ===== Overlay ===== */
.overlaytopbar {
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.432);
  position: fixed;
  top: 0; left: 0; bottom: 0; right: 0;
  z-index: 9;
  display: none;
}
@media (max-width: 918px) {
  .overlaytopbar { display: block; }
}

/* ===== Nav base ===== */
nav { flex: 1 1 100%; }
nav ul { list-style: none; }
#mobile-icon, [id^="submenu"] { display: none; }

nav a, nav label {
  font-weight: 500;
  font-size: 12px;
  color: black;
  background: #fff;
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 0px 5px;
  height: 45px;
  transition: background 0.4s ease-out;
}
nav a:hover, nav label:hover { background: lightblue; }
.arrow { margin-left: 9px; margin-top: 4px; color: #eee; font-size: 10px; }
.nav-items li a svg { height: 19px; width: 19px; }

/* ===== Submenu styling ===== */
.submenu-home, .submenu-1, .submenu-3, .submenu-4,
.submenu-6, .submenu-ev, .submenu-8, .submenu-9 {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.submenu-home a, .submenu-1 a, .submenu-3 a, .submenu-4 a,
.submenu-6 a, .submenu-ev a, .submenu-8 a, .submenu-9 a {
  font-size: 12px;
}

.disabledSection { background-color: #ba0b23; color: #fff; pointer-events: none; }
.goto-page-link { background-color: #ba0b23; color: #fff; }
.goto-page-link:hover { background-color: #ba0b23; color: #fff; }

/* ===== Mobile nav ===== */
@media (max-width: 918px) {
  nav ul { max-height: 0; overflow: scroll; transition: max-height 0.3s ease-out; }
  #mobile-icon:checked ~ nav > ul { max-height: 80vh; }
  [id^="submenu"]:checked ~ [class^="submenu"] { max-height: 100vh; overflow: visible; }
  .hamburger-icon {
    width: 18px; height: 3px;
    background-color: #6b0a23;
    display: block; position: relative;
  }
  .hamburger-icon:before, .hamburger-icon:after {
    content: ""; display: block;
    width: 100%; height: 100%;
    position: absolute;
    background-color: #6b0a23;
    transition: all 0.2s;
  }
  .hamburger-icon:before { top: 5px; }
  .hamburger-icon:after { top: -5px; }
  #mobile-icon:checked ~ .toggle { border-radius: 50em; transition: all 0.2s ease-out; }
  .nav-items li { display: flex; flex-direction: column; }
  .hide-mobile { display: none; }
}

/* ===== Desktop nav ===== */
@media (min-width: 919px) {
  .login-profile-topbar-A01 { flex-wrap: nowrap; }
  nav { flex: none; margin-right: 70px; }
  .toggle, nav label { display: none; }
  nav ul { display: flex; }
  nav li { position: relative; }
  nav ul ul { max-height: 0; overflow: hidden; transition: max-height 0.2s ease-out; }
  li:hover > ul { max-height: 100vh; overflow: visible; }
  [class^="submenu"] { flex-direction: column; position: absolute; }
  .submenu-home, .submenu-1, .submenu-3, .submenu-4,
  .submenu-6, .submenu-ev, .submenu-8, .submenu-9 {
    width: 160px;
    left: 0;
  }
}

/* ===== Count badge ===== */
.count {
  position: absolute;
  top: 7px; right: 17px;
  background: #fa4040;
  color: white;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  padding: 2px 4px;
  border-radius: 20px;
}

/* ===== Multiselect (same as doc2) ===== */
.multiselect {
  width: 700px !important;
  height: 20px !important;
  margin-left: 10px;
}
.multiselect__tags {
  min-height: 40px;
  display: block;
  padding: 8px 5px 0 8px !important;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 13px;
}

@media only screen and (max-width: 600px) {
  .multiselect { width: 50vw !important; height: 16px !important; padding: 4px !important; margin-bottom: 10px; }
}
@media only screen and (max-width: 500px) {
  .multiselect { width: 65vw !important; }
}

/* ===== Setting Box ===== */
.setting-box {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: flex-end;
  padding: 60px 20px 20px;
  z-index: 9999;
}
.TopbarSetting {
  width: 320px;
  max-height: 85vh;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  animation: fadeSlide 0.2s ease;
  position: relative !important;
}
.pageSettingHeading { font-size: 18px; font-weight: 600; margin-bottom: 14px; }
.layoutHeading { font-size: 13px; font-weight: 500; color: #555; margin-bottom: 6px; }
.editBackgroundBtn {
  width: 100%; padding: 8px; border-radius: 8px;
  border: 1px solid #ddd; background: #f7f7f7;
  font-size: 13px; cursor: pointer; transition: 0.2s ease;
}
.editBackgroundBtn:hover { background: #ececec; }
.ThemeSelection {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(34px, 1fr));
  gap: 8px;
  margin-top: 8px;
}
.theme {
  width: 34px; height: 34px;
  border-radius: 8px; cursor: pointer;
  border: 1px solid #eee; transition: 0.2s ease;
}
.theme:hover { transform: scale(1.08); border-color: #ccc; }
.PagrHR { margin: 12px 0; opacity: 0.2; }
.layout { display: grid; grid-template-columns: repeat(3, 1fr); text-align: center; }
.layoutBackground { display: grid; grid-template-columns: repeat(2, 1fr); }

@keyframes fadeSlide {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>